import { http } from '@/api/client/httpClient';

export interface EditLogRowDto {
  editDate: string;
  user: string;
  ticket: number;
  login: number;
  transactionDate: string | null;
  oldProvider: string;
  newProvider: string;
  oldProviderType: string;
  newProviderType: string;
  connector: string;
  comment: string;
}

const BASE = '/api/app/edit-logs';

export const editLogsApi = {
  getLogs: () => http.get<EditLogRowDto[]>(`${BASE}/logs`).then((r) => r.data),
};
